import React from 'react'
import { css } from '@emotion/css'
import { AttackStatus } from '../../attack-status'
import { AttackStatusBadge } from '../../badge'

export function ResultCell({
  rowData: { result }
}: {
  readonly rowData: {
    readonly result: AttackStatus
  }
}) {
  return (
    <div
      className={css`
        margin-left: 8px;
      `}
    >
      <AttackStatusBadge status={result} />
    </div>
  )
}
